<template>
  <FormStepper :steps="steps" :formData="formData" class="p-4 p-md-5" style="max-width: 1200px;line-height: 1.5em;font-size: 16px;"></FormStepper>
</template>

<script>
import FormStepper from '@/components/FormStepper';

import Step1 from "./steps/Step1";
import SuccessPage from "./steps/Success";
import initialFormData from './initialFormData';

export default {
  name: "ForwardOrder",
  data() {
    return {
      formData: initialFormData,
      steps: [
        Step1,
        SuccessPage
      ]
    }
  },
  components: {
    FormStepper,
    Step1,
    SuccessPage
  }
}
</script>

<style scoped>
.formStepper {
  background-color: #f9f9f9;
  border-radius: 0.25em;
  box-shadow: 0 6px 23px #ccc;
}
</style>
